import { http_client } from "@/plugins/http_client";

const obtenerAgrupadores = async (params) =>
  http_client("/api/gestion-roles/agrupadores", params, "get");

const guardarAgrupador = async (body) =>
  http_client("/api/gestion-roles/agrupador", body, "post");

const editarAgrupador = async (id, body) =>
  http_client(`/api/gestion-roles/agrupador/${id}`, body, "put");

const cambiarEstadoAgrupador = async (id) =>
  http_client(`/api/gestion-roles/agrupador/${id}/estado`, {}, "put");

const obtenerAgrupador = async (id) =>
  http_client(`/api/gestion-roles/agrupador/${id}`, {}, "get");

//Catalogos
const obtenerNiveles = async (params) =>
  http_client("/api/gestion-roles/niveles", {}, "get");

const obtenerTipoUnidad = async (params) =>
  http_client("/api/gestion-roles/tipos-unidad", {}, "get");

export default {
  obtenerAgrupadores,
  guardarAgrupador,
  editarAgrupador,
  cambiarEstadoAgrupador,
  obtenerAgrupador,
  obtenerNiveles,
  obtenerTipoUnidad,
};
